import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchData } from "../../Services/GlobalService";
import Loader from "../../Components/Loader";

const BannerUploadDB = () => {
  const Controller = "BannerImageForDealerApp";
  const Endpoints = {
    AllBannerDtls: "AllBannerDtls",
  };

  const [allRecords, setAllRecords] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);

  const Pageload = async () => {
    setLoading(true);
    try {
      const AllBannerDtlsRes = await fetchData(
        Controller,
        `${Endpoints.AllBannerDtls}`,
        `TenantType=DB`,
      );
      setAllRecords(AllBannerDtlsRes.Data);
    } catch (e) {
      console.log("Error", e);
    } finally {
      setLoading(false);
    }
  };

  const renderImage = (rowData: any) => {
    return (
      <img
        src={`${rowData?.BANNER_IMG_URL}`}
        style={{ width: "100px" }}
        alt="Order Banner"
      />
    );
  };

  useEffect(() => {
    Pageload();
  }, []);

  if (loading) {
    return (
      <>
        <Loader />
      </>
    );
  } else {
    return (
      <>
        <main>
          <div className="col-12 mb-5">
            <div className="row">
              {/* Breadcrumb  */}
              <div className="">
                <nav aria-label="breadcrumb" className="drop-in">
                  <ol className="breadcrumb mx-0">
                    <li className="breadcrumb-item" aria-current="page">
                        Banner Upload
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Secondary Upload
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12">
                <h3 className="py-2">Secondary Upload</h3>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="text-end">
                  <Link to="/BannerUpload/DB/View">
                    <button
                      type="button"
                      title="Save"
                      className="btn anime-btn"
                    >
                      Add New
                    </button>
                  </Link>
                </div>
              </div>
            </div>

            <div className="DataTable">
              <DataTable
                value={allRecords}
                dataKey=""
                paginator
                rows={10}
                filterDisplay="row"
                scrollable
                rowsPerPageOptions={[10, 25, 50]}
                scrollHeight="80vh"
                showGridlines
                stripedRows
                emptyMessage="No record found."
                tableStyle={{ minWidth: "60rem" }}
              >
                <Column
                  field="BANNER_NAME"
                  header="Banner Name"
                  filter
                  filterMatchMode="contains"
                  filterPlaceholder="Search Here..."
                />
                <Column
                  body={renderImage}
                  header="Banner Image"
                  filter
                  filterMatchMode="contains"
                  filterPlaceholder="Search Here..."
                />
                <Column
                  field="START_DATE"
                  header="Start Date"
                  filter
                  filterMatchMode="contains"
                  filterPlaceholder="Search Here..."
                />
                <Column
                  field="END_DATE"
                  header="End Date"
                  filter
                  filterMatchMode="contains"
                  filterPlaceholder="Search Here..."
                />
                <Column
                  field="STREAM_CHANNEL_DESC"
                  header="Stream"
                  filter
                  filterMatchMode="contains"
                  filterPlaceholder="Search Here..."
                />
                <Column
                  body={(rowData) => (rowData?.IS_BNR_CLKBL ? "Yes" : "No")}
                  header="Clickable Banner"
                  filterMatchMode="contains"
                  filterPlaceholder="Search Here..."
                />
              </DataTable>
            </div>
          </div>
        </main>
      </>
    );
  }
};

export default BannerUploadDB;
